NtechApp.Catalog = function($view) {
    var me = this;

    this._$view = null;

    this._touchClickEvent = null;

    this._$collectionInfo = null;
    //this._$leftParallaxOverlay = null;
    //this._$rightParallaxOverlay = null;

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;

        me._$collectionInfo = me._$view.find(".collectionInfo");
        //me._$leftParallaxOverlay = $("<div class='catalogParallaxOverlay'></div>").appendTo("body");
        //me._$rightParallaxOverlay = $("<div class='catalogParallaxOverlay'></div>").appendTo("body");

        me._touchClickEvent = new NtechApp.TouchClickEvent();

        // Fix for parallax scroller
        me._createParallaxScroller();
        //me._createParallaxOverlays();
        //me._updateParallaxOverlays();

        setTimeout(function() {
            $(window).trigger("scroll");
            $(document).trigger(NtechApp.Catalog.EVENT_DOCUMENT_SCROLL);
        }, 200);

        me._bindEvents();
    }

    this._bindEvents = function () {
        $(window).on(NtechApp.Catalog.EVENT_DOCUMENT_RESIZE, function() {
           // me._updateParallaxOverlays();
            setTimeout(function() {
                $(window).trigger("scroll");
                $(document).trigger(NtechApp.Catalog.EVENT_DOCUMENT_SCROLL);
            }, 200);
        });

        $(document).on(NtechApp.Catalog.EVENT_DOCUMENT_SCROLL, function() {
            //me._updateParallaxOverlays();
        });

        //me._$view.on("mouseenter.NtechApp.Catalog", ".gridItem", function(event) {
        //    $(this).find(".overlay").addClass("show");
        //    $(this).find(".name").addClass("selected");
        //});
        //
        //me._$view.on("mouseleave.NtechApp.Catalog", ".gridItem", function(event) {
        //    $(this).find(".overlay").removeClass("show");
        //    $(this).find(".name").removeClass("selected");
        //});
    }

    this._unbindEvents = function () {
        $(window).off(NtechApp.Catalog.EVENT_DOCUMENT_RESIZE);
        $(document).off(NtechApp.Catalog.EVENT_DOCUMENT_SCROLL);
        //me._$view.off("mouseenter.NtechApp.Catalog");
        //me._$view.off("mouseleave.NtechApp.Catalog");
        $(".collectionInfo > .image").imageScroll("destroy");
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Catalog.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Catalog";
NtechApp.Catalog.EVENT_DOCUMENT_RESIZE = "resize.NtechApp.Catalog";

NtechApp.Catalog.prototype._createParallaxScroller = function() {
    $(".collectionInfo > .image").imageScroll({
        holderMaxHeight: 470,
        container: $(".collectionInfo")
    });
};

//NtechApp.Catalog.prototype._createParallaxOverlays = function() {
//    this._$leftParallaxOverlay.css({
//        position: "absolute",
//        left: "0px",
//        top: this._$catalogInfo.offset().top - 100 + "px",
//        width: "3%",
//        height: this._$catalogInfo.height() + 140 + "px",
//        background: "white",
//        zIndex: "100"
//    });
//
//    this._$rightParallaxOverlay.css({
//        position: "absolute",
//        right: "0px",
//        top: this._$catalogInfo.offset().top - 100 + "px",
//        width: "3%",
//        height: this._$catalogInfo.height() + 140 + "px",
//        background: "white",
//        zIndex: "100"
//    });
//};
//
//NtechApp.Catalog.prototype._updateParallaxOverlays = function() {
//    this._$leftParallaxOverlay.css({
//        top: this._$catalogInfo.offset().top - 100 + "px",
//        height: this._$catalogInfo.height() + 140 + "px"
//    });
//    this._$rightParallaxOverlay.css({
//        top: this._$catalogInfo.offset().top - 100 + "px",
//        height: this._$catalogInfo.height() + 140 + "px"
//    });
//};